import { render, staticRenderFns } from "./DriverPaySettings.vue?vue&type=template&id=845e1be8&"
import script from "./DriverPaySettings.vue?vue&type=script&lang=js&"
export * from "./DriverPaySettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports